export let modalVars = {
  auth: false,
  'created-account': false,
  'created-newsletter-only-account': false,
  'error-modal': false,
  'forgot-password': false,
  'reset-password': false,
  'claim-booking': false,
  'change-password': false,
  'more-information': false,
  'identity-verification-error': false,
  'success-message': false,
  'cookies-preferences-modal': false,
  'help-booking-info': false,
  'send-access-codes': false,
  'how-to-access-instructions': false,
  'cancel-booking-modal': false,
  'feedback-tool': false,
  'checkin-upload-process': false,
  'quick-feedback-response': false,
  'my-bookings-tooltip': false,
  'pdp-sorting-options': true,
  'feedback-booking-journey': false,
  'select-field-picker': false,
  'checkin-selfie-video': false,
  'coming-soon': false,
  'travel-sustainable-measures': false,
  'how-it-works': false,
  'guest-picker': false,
  'guest-picker-inventory': false,
  'checkout-leave': false,
  'mobile-booking-widget-edit': false,
  'pdp-share-options': false,
  'add-booking': false,
  'qa-test-modal-1': false,
  'qa-test-modal-2': false,
  'help-center-contact-us': false,
  'limeapp-promotion': false,
  'cart-details': false,
  'add-room': false
};

export type ModalUnionType = keyof typeof modalVars;
